import PRODUCT_FRAGMENT from 'graph/fragments/product';
import PRODUCT_CURRICULUM_FRAGMENT from 'graph/fragments/product-curriculum';
import gql from 'graphql-tag';

const GET_STUDENT_CURRICULUM_LESSON_REPORT = gql`
  query getStudentCurriculumLessonReport($studentId: Int!) {
    prmStudentCurriculumLessonReport(where: { studentId: $studentId }) {
      studentId
      student {
        id
        firstName
        lastName
        gradeLevel
        licenseUsage {
          active
          assignedCount
          product {
            ...BaseProduct
          }
          productCurriculum {
            ...BaseProductCurriculum
          }
          productCurriculumId
          productId
          trial
        }
      }
      curriculumDetail {
        lessonAssignedCount
        productCurriculumId
        productCurriculum {
          id
          name
        }
        lastLoginDate
        currentLessonId
        currentLesson {
          lessonNumber
        }
        totalLessonCount
      }
      lessonDetail {
        averageLessonTimeSpentSeconds
        lessons {
          timeSpentSeconds

          lessonId
          lesson {
            lessonNumber
            title
            primarySkillPhonics
            primarySkillWordStudy
          }
          metSkill
          usedSupport
          timeSpentSeconds
        }
      }
    }
  }
  ${PRODUCT_FRAGMENT}
  ${PRODUCT_CURRICULUM_FRAGMENT}
`;

export default GET_STUDENT_CURRICULUM_LESSON_REPORT;
